import { DEACTIVATE_REASONS_TYPES } from 'types/account-types';

export const DEACTIVATION_REASONS = [
  {
    text: "I'm not satisfied with the return",
    value: DEACTIVATE_REASONS_TYPES.NOT_SATISFIED,
  },
  {
    text: 'Too many bugs',
    value: DEACTIVATE_REASONS_TYPES.TOO_MANY_BUGS,
  },
  {
    text: 'I need the cash now',
    value: DEACTIVATE_REASONS_TYPES.NEED_MONEY,
  },
  {
    text: 'Something else',
    value: DEACTIVATE_REASONS_TYPES.ELSE,
  },
];
